
 const initialState = {
  productDetails:'' 
} 

export default function productListView( state = initialState, action) {
  console.log(action,"action.type====>productList",action.payload)
if(action.type==='Product_Details'){
    return {
      ...state,
      productDetails:action.payload,
    }
  }
  return state; 

}


